import React, { createContext, useContext, useState } from "react";

// ─── All available roles ──────────────────────────────────────────────────────
export const ALL_ROLES = [
  "Super Admin",
  "Org Admin",
  "Org Manager",
  "Site Admin",
  "Operator",
  "Technician",
  "Viewer",
];

// ─── View type each role belongs to ──────────────────────────────────────────
export const ROLE_VIEW = {
  "Super Admin": "platform",
  "Org Admin":   "org",
  "Org Manager": "org",
  "Site Admin":  "site",
  "Operator":    "site",
  "Technician":  "site",
  "Viewer":      "site",
};

// ─── View badge labels + colors for TopNavBar ─────────────────────────────────
export const VIEW_BADGE = {
  platform: { label: "Platform View", color: "#7c3aed" },
  org:      { label: "Org View",      color: "#0ea5e9" },
  site:     { label: "Site View",     color: "#16a34a" },
};

// ─── Demo users per role (shown in role switcher) ─────────────────────────────
export const DEMO_USERS = {
  "Super Admin": { name: "IoTMATE Admin",  initials: "IA" },
  "Org Admin":   { name: "Arjun Tata",     initials: "AT" },
  "Org Manager": { name: "Deepak Verma",   initials: "DV" },
  "Site Admin":  { name: "Rajesh Mehta",   initials: "RM" },
  "Operator":    { name: "Kavita Sharma",  initials: "KS" },
  "Technician":  { name: "Sunil Patil",    initials: "SP" },
  "Viewer":      { name: "Mohan Rao",      initials: "MR" },
};

// ─── Context ──────────────────────────────────────────────────────────────────
const RoleContext = createContext({});

export const RoleProvider = ({ children }) => {
  const [currentRole, setCurrentRole] = useState("Org Admin");

  const currentView = ROLE_VIEW[currentRole] || "org";
  const currentUser = DEMO_USERS[currentRole] || { name: "User", initials: "U" };

  return (
    <RoleContext.Provider value={{ currentRole, setCurrentRole, currentView, currentUser }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
export default RoleContext;
